import { render, staticRenderFns } from "./ProductPurchaseForm.vue?vue&type=template&id=9a1fd92a&scoped=true&"
import script from "./ProductPurchaseForm.vue?vue&type=script&lang=js&"
export * from "./ProductPurchaseForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductPurchaseForm.vue?vue&type=style&index=0&id=9a1fd92a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1fd92a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiReadMore: require('/app/components/UI/UiReadMore.vue').default,UiButton: require('/app/components/UI/UiButton.vue').default,UiSpinner: require('/app/components/UI/UiSpinner.vue').default,UiIcon: require('/app/components/UI/UiIcon.vue').default})
